import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const NewWindow = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='NewWindow' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M11,9 L19,9 M15,13 L15,5 M17,17 L17,23 L1,23 L1,7 L1,7 L7,7 M7,1 L23,1 L23,17 L7,17 L7,1 Z' />
  </StyledIcon>
);
